import Alpine from 'alpinejs';

import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

import AsyncForm from './components/async-form';
import PageNav from './components/page-nav';
import PageNavNav from './components/page-nav-nav';

Alpine.plugin(intersect);
Alpine.plugin(collapse);

window.Alpine = Alpine;

Alpine.data('asyncForm', AsyncForm);
Alpine.data('pageNav', PageNav);
Alpine.data('pageNavNav', PageNavNav);

Alpine.start();
